import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { IDeliveryInfo } from '../../modules/basket/types/DeliveryDetails';

const initialState: IDeliveryInfo = {
  deliveryPrice: 0,
  deliveryTime: 0,
};

const deliveryTimeSlice = createSlice({
  name: 'deliveryTime',
  initialState,
  reducers: {
    setDeliveryTime: (state, action: PayloadAction<IDeliveryInfo>) => {
      state.deliveryPrice = action.payload.deliveryPrice;
      state.deliveryTime = action.payload.deliveryTime;
    },
  },
});

export const { setDeliveryTime } = deliveryTimeSlice.actions;
export default deliveryTimeSlice.reducer;
